const actions = {
  CORTE_CAJA: 'CORTE_CAJA',

  corteCajaList: data => {
    return {
      type: actions.CORTE_CAJA,
      data,
    };
  },
};

export default actions;
